const LogoWithText = ({ width = 119, height = 30, color = 'white', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 119 30"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_5666_110372"
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="10"
        y="18"
        width="11"
        height="12"
      >
        <path
          d="M18.4622 20.4758C17.8639 20.8788 17.1996 21.1859 16.4959 21.3848C15.2677 21.7271 12.4006 22.5522 11.8018 22.7183C11.592 22.7642 11.3995 22.8637 11.2451 23.0058C11.0908 23.1479 10.9805 23.3273 10.9263 23.5246V29.0333C10.9254 29.1994 10.97 29.3629 11.0557 29.5079C11.1415 29.6529 11.2654 29.7744 11.4155 29.8606C11.5656 29.9468 11.7367 29.9947 11.9122 29.9997C12.0877 30.0047 12.2615 29.9667 12.4168 29.8892L19.5313 26.3508C19.6891 26.2722 19.8213 26.1543 19.9134 26.0097C20.0055 25.8652 20.0542 25.6996 20.0541 25.5309V18.1699C20.0215 19.1714 19.2256 19.952 18.4622 20.4724"
          fill={color}
        />
      </mask>
      <g mask="url(#mask0_5666_110372)">
        <path
          d="M20.041 17.8283L10.418 18.1924L10.941 30.5677L20.564 30.2035L20.041 17.8283Z"
          fill="url(#paint0_linear_5666_110372)"
        />
      </g>
      <path
        d="M20.0497 15.7905V18.1734C20.0171 19.1748 19.2212 19.9554 18.4578 20.4758C17.8595 20.8789 17.1952 21.186 16.4915 21.3848C15.2633 21.7272 12.3961 22.5523 11.7974 22.7184C11.5876 22.7643 11.3951 22.8637 11.2407 23.0059C11.0864 23.148 10.9761 23.3274 10.9219 23.5246C10.922 23.3229 10.9867 23.1259 11.1074 22.9597C11.2282 22.7934 11.3994 22.6657 11.5984 22.5934L16.0013 21.1537C16.0013 21.1537 20.0497 19.9554 20.0497 15.7905Z"
        fill="#FEDA2C"
      />
      <mask
        id="mask1_5666_110372"
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="11"
        y="7"
        width="10"
        height="16"
      >
        <path
          d="M16.7253 14.3276L16.1609 17.4569L15.5567 20.8635C15.5398 20.9617 15.4958 21.054 15.4291 21.1309C15.3624 21.2079 15.2754 21.2668 15.1769 21.3017L11.6042 22.5924L16.0054 21.1528C16.0054 21.1528 20.0537 19.9545 20.0537 15.7896C20.0537 12.9 18.1887 10.4691 15.9909 8.96101C15.2717 8.46226 14.4866 8.0548 13.6556 7.74902C17.6641 9.38383 16.7307 14.3276 16.7307 14.3276"
          fill={color}
        />
      </mask>
      <g mask="url(#mask1_5666_110372)">
        <path
          d="M20.0537 7.74902H11.6042V22.5941H20.0537V7.74902Z"
          fill="url(#paint1_linear_5666_110372)"
        />
      </g>
      <mask
        id="mask2_5666_110372"
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="13"
        y="7"
        width="5"
        height="14"
      >
        <path
          d="M13.7912 7.80551C14.3429 8.04323 14.8419 8.37782 15.2618 8.79154C17.3801 10.8817 16.7253 14.3276 16.7253 14.3276L16.1609 17.4569L15.5567 20.8635L16.9206 14.8634C16.9206 14.8634 18.0313 10.7807 15.9926 8.96101C15.7647 8.80694 15.5368 8.66144 15.3053 8.5262C14.8234 8.2433 14.3169 7.9999 13.7912 7.79867C13.7478 7.78155 13.7025 7.76443 13.6555 7.74902C13.7025 7.76614 13.7478 7.78497 13.7912 7.80551Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask2_5666_110372)">
        <path
          d="M18.0312 7.74902H13.6572V20.8635H18.0312V7.74902Z"
          fill="url(#paint2_linear_5666_110372)"
        />
      </g>
      <mask
        id="mask3_5666_110372"
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="18"
        width="10"
        height="12"
      >
        <path
          d="M1.07662e-05 25.5262C-0.000820906 25.6939 0.0465458 25.8586 0.137041 26.0027C0.227535 26.1469 0.35775 26.265 0.513743 26.3445L7.63003 29.8828C7.78535 29.9603 7.95921 29.9984 8.13468 29.9934C8.31016 29.9883 8.48128 29.9404 8.63136 29.8542C8.78145 29.768 8.9054 29.6465 8.99113 29.5016C9.07686 29.3566 9.12146 29.1931 9.12059 29.0269V23.5285C9.06572 23.3314 8.95528 23.1521 8.80107 23.0097C8.64686 22.8674 8.45468 22.7674 8.24507 22.7205C7.64632 22.5493 4.78099 21.7379 3.55092 21.3887C2.85194 21.1869 2.19261 20.8781 1.5991 20.4746C0.835731 19.961 0.0398058 19.1736 0.00724523 18.1704L1.07662e-05 25.5262Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask3_5666_110372)">
        <path
          d="M0.00243089 17.9836L-0.277344 30.2153L9.12322 30.4079L9.403 18.1762L0.00243089 17.9836Z"
          fill="url(#paint3_linear_5666_110372)"
        />
      </g>
      <path
        d="M0 15.7905V18.1717C0.0325606 19.1748 0.828485 19.9554 1.59185 20.4758C2.18977 20.8791 2.85422 21.1856 3.55815 21.3831C4.78821 21.734 7.65354 22.5523 8.25048 22.7166C8.46042 22.7633 8.65299 22.8632 8.80754 23.0055C8.96209 23.1479 9.0728 23.3273 9.12781 23.5246C9.12808 23.3226 9.06332 23.1252 8.94214 22.9589C8.82096 22.7925 8.64911 22.665 8.44946 22.5934L4.04836 21.1537C4.04836 21.1537 0 19.9554 0 15.7905Z"
        fill="#FEDA2C"
      />
      <mask
        id="mask4_5666_110372"
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="7"
        width="9"
        height="16"
      >
        <path
          d="M4.06102 8.96077C1.86319 10.4689 0 12.898 0 15.7893C0 19.9491 4.04836 21.1525 4.04836 21.1525L8.44946 22.5922L4.87504 21.3032C4.77616 21.2681 4.68881 21.2089 4.6218 21.1317C4.55479 21.0544 4.51049 20.9618 4.49336 20.8632L3.88918 17.4566L3.32479 14.3274C3.32479 14.3274 2.38416 9.38359 6.39996 7.74707C5.56942 8.05453 4.78445 8.46249 4.06464 8.96077"
          fill={color}
        />
      </mask>
      <g mask="url(#mask4_5666_110372)">
        <path
          d="M8.45127 7.74707H0V22.5922H8.45127V7.74707Z"
          fill="url(#paint4_linear_5666_110372)"
        />
      </g>
      <mask
        id="mask5_5666_110372"
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="7"
        width="14"
        height="15"
      >
        <path
          d="M6.79445 7.60889C6.66421 7.64997 6.53397 7.69277 6.40011 7.7407C2.39154 9.37723 3.32494 14.321 3.32494 14.321L3.82782 17.1148C3.84608 17.2153 3.89449 17.3088 3.96729 17.3841C4.04009 17.4593 4.13421 17.5132 4.23845 17.5393L8.83491 18.6999C8.89448 18.7212 8.94579 18.7591 8.98198 18.8086C9.01818 18.8582 9.03755 18.917 9.03751 18.9772V20.583C9.03803 20.6988 9.0787 20.8112 9.15328 20.9031L9.60009 21.4029C9.65289 21.4623 9.71879 21.5101 9.79316 21.5429C9.86753 21.5756 9.94858 21.5926 10.0306 21.5926C10.1126 21.5926 10.1937 21.5756 10.2681 21.5429C10.3424 21.5101 10.4083 21.4623 10.4611 21.4029L10.9079 20.9031C10.9825 20.8112 11.0232 20.6988 11.0237 20.583V18.9772C11.0235 18.9172 11.0426 18.8585 11.0785 18.809C11.1144 18.7595 11.1653 18.7214 11.2245 18.6999L15.8155 17.5461C15.9198 17.5204 16.0138 17.4665 16.0864 17.3912C16.159 17.3158 16.2069 17.2222 16.2244 17.1216L16.729 14.3279C16.729 14.3279 17.6679 9.38407 13.6539 7.74926C13.5218 7.70133 13.3898 7.65682 13.2595 7.61745C11.3746 7.03542 10.027 7.8845 10.027 7.8845C9.44548 7.56564 8.78334 7.40233 8.11135 7.41203C7.66209 7.41315 7.21584 7.48132 6.78903 7.61403"
          fill={color}
        />
      </mask>
      <g mask="url(#mask5_5666_110372)">
        <path
          d="M17.665 7.03418H2.38867V21.6568H17.665V7.03418Z"
          fill="url(#paint5_linear_5666_110372)"
        />
      </g>
      <mask
        id="mask6_5666_110372"
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="7"
        width="5"
        height="14"
      >
        <path
          d="M4.06078 8.96077C2.02213 10.7787 3.13281 14.8632 3.13281 14.8632L4.49312 20.8632L3.88894 17.4567L3.32455 14.3274C3.32455 14.3274 2.38391 9.38359 6.39972 7.74707C5.56917 8.05453 4.78421 8.46249 4.0644 8.96077"
          fill={color}
        />
      </mask>
      <g mask="url(#mask6_5666_110372)">
        <path
          d="M6.39619 7.74707H2.02222V20.8632H6.39619V7.74707Z"
          fill="url(#paint6_linear_5666_110372)"
        />
      </g>
      <mask
        id="mask7_5666_110372"
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="0"
        width="10"
        height="17"
      >
        <path
          d="M6.32983 2.00371C6.04779 2.13191 5.81726 2.34317 5.67279 2.6058C5.52831 2.86844 5.47768 3.16832 5.52848 3.46049L6.04764 6.52811L6.21044 7.49188L7.21801 13.4525C7.27454 13.7809 7.44513 14.0821 7.7028 14.3084L10.0273 16.3627L10.0399 16.3507L12.3499 14.317C12.6081 14.0908 12.7794 13.7896 12.8365 13.4611L13.8278 7.59802L14.0087 6.5846L14.1896 5.5575L14.5514 3.46905C14.6012 3.17722 14.5499 2.87796 14.4051 2.61601C14.2604 2.35405 14.0299 2.14346 13.7482 2.01569L10.0508 0.22168L6.32983 2.00371Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask7_5666_110372)">
        <path
          d="M14.627 0.212402H5.42505V16.3551H14.627V0.212402Z"
          fill="url(#paint7_linear_5666_110372)"
        />
      </g>
      <mask
        id="mask8_5666_110372"
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="0"
        width="10"
        height="17"
      >
        <path
          d="M7.72331 14.2562C7.46586 14.0302 7.29635 13.7287 7.24214 13.4003L6.24361 7.49274L6.08081 6.53753L5.56708 3.50072C5.51902 3.21144 5.57021 2.9152 5.71313 2.65548C5.85605 2.39575 6.08319 2.18622 6.36119 2.05764L10.0261 0.282453L13.6909 2.05935C13.9683 2.18776 14.195 2.39674 14.3378 2.65576C14.4807 2.91478 14.5323 3.21026 14.4851 3.49901L14.1359 5.56863L13.955 6.58546L13.785 7.59032L12.8136 13.4072C12.7606 13.7355 12.5916 14.0372 12.3342 14.2631L10.0442 16.2779L10.0315 16.2899L7.72331 14.2562ZM9.89401 0.059913L6.24181 1.8351C5.91037 1.98566 5.63951 2.23393 5.46989 2.54261C5.30028 2.85128 5.24107 3.20371 5.30117 3.54694L5.81671 6.58204L5.9777 7.53896L6.97804 13.4448C7.04253 13.8271 7.24061 14.1779 7.54061 14.4411L9.84337 16.4679L10.0243 16.6271L10.2051 16.4697L10.2178 16.4577L12.5097 14.4411C12.8087 14.1772 13.0066 13.8267 13.0723 13.4448L14.0545 7.63654V7.61599L14.221 6.63168L14.4018 5.61485L14.7528 3.54523V3.52469C14.8066 3.18502 14.744 2.83795 14.5741 2.53446C14.4041 2.23097 14.1358 1.98704 13.8085 1.83852L10.1491 0.059913L10.0261 0L9.89401 0.059913Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask8_5666_110372)">
        <path d="M14.8637 0H5.18237V16.6289H14.8637V0Z" fill="url(#paint8_linear_5666_110372)" />
      </g>
      <mask
        id="mask9_5666_110372"
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="0"
        width="10"
        height="17"
      >
        <path
          d="M6.32955 2.0047C6.04786 2.13282 5.81756 2.3438 5.67311 2.60609C5.52866 2.86837 5.47782 3.16786 5.5282 3.45976L6.04555 6.5291L6.21016 7.49287L7.21773 13.4535C7.21849 13.4655 7.21849 13.4775 7.21773 13.4895C7.22835 13.5473 7.24285 13.6045 7.26115 13.6606C7.34451 13.9082 7.49332 14.1316 7.69348 14.3094L10.0179 16.3534L10.0306 16.3431L12.3406 14.3094C12.5988 14.0832 12.77 13.7821 12.8272 13.4535L13.8185 7.59045L13.9994 6.57703L14.1803 5.54993L14.5421 3.46148C14.5915 3.16991 14.5399 2.87104 14.3952 2.60944C14.2505 2.34784 14.0202 2.13751 13.7389 2.00983L10.0415 0.21582L6.32955 2.0047Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask9_5666_110372)">
        <path
          d="M14.6282 0.212402H5.42627V16.3551H14.6282V0.212402Z"
          fill="url(#paint9_linear_5666_110372)"
        />
      </g>
      <mask
        id="mask10_5666_110372"
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="10"
        y="0"
        width="5"
        height="17"
      >
        <path
          d="M10.026 16.3111L10.0387 16.3436L12.3487 14.3099C12.6069 14.0837 12.7781 13.7825 12.8353 13.454L13.7867 7.82373L13.8265 7.59092L14.0074 6.57751L14.1883 5.5504L14.5501 3.46195C14.5869 3.24501 14.5679 3.02288 14.4949 2.81432C14.4218 2.60576 14.2968 2.41689 14.1304 2.26366C14.1205 2.25308 14.1096 2.24334 14.0979 2.23456C14.0849 2.22166 14.071 2.20965 14.0563 2.19861L14.0074 2.16095L13.9477 2.12158L13.9007 2.08905L13.8826 2.07878L13.8501 2.06167C13.8501 2.06167 13.8501 2.06167 13.8392 2.06167C13.8248 2.05266 13.8096 2.04466 13.794 2.0377L13.7542 2.01716L10.0568 0.223145L10.026 16.3111Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask10_5666_110372)">
        <path
          d="M11.1438 -1.64379L2.70386 12.4102L13.4831 18.2073L21.923 4.1534L11.1438 -1.64379Z"
          fill="url(#paint10_linear_5666_110372)"
        />
      </g>
      <mask
        id="mask11_5666_110372"
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="13"
        y="2"
        width="2"
        height="6"
      >
        <path
          d="M14.5273 3.45783L14.1655 5.54628L13.9846 6.57338L13.8037 7.5868L13.7639 7.81961L13.9918 7.88295L14.6575 3.9457C14.7534 3.04527 14.3898 2.52316 14.0841 2.25098C14.2505 2.4042 14.3755 2.59307 14.4485 2.80163C14.5216 3.01019 14.5405 3.23232 14.5038 3.44927"
          fill={color}
        />
      </mask>
      <g mask="url(#mask11_5666_110372)">
        <path
          d="M13.8393 2.05356L12.4709 7.59619L14.7257 8.09468L16.094 2.55205L13.8393 2.05356Z"
          fill="url(#paint11_linear_5666_110372)"
        />
      </g>
      <mask
        id="mask12_5666_110372"
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="2"
        width="2"
        height="6"
      >
        <path
          d="M5.37333 3.9557L6.03901 7.89294L6.26693 7.8296L6.22713 7.59679L6.04624 6.58338L5.86535 5.55627L5.50357 3.46782C5.46681 3.25088 5.48576 3.02875 5.5588 2.82019C5.63184 2.61163 5.75684 2.42276 5.92324 2.26953C5.61753 2.54171 5.25394 3.06383 5.348 3.96426"
          fill={color}
        />
      </mask>
      <g mask="url(#mask12_5666_110372)">
        <path
          d="M6.21736 2.05283L3.96265 2.55127L5.33112 8.09386L7.58584 7.59542L6.21736 2.05283Z"
          fill="url(#paint12_linear_5666_110372)"
        />
      </g>
      <mask
        id="mask13_5666_110372"
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="7"
        y="13"
        width="4"
        height="4"
      >
        <path
          d="M8.01554 14.8608L10.0252 16.6289L10.0397 16.3448L10.0271 16.3551L7.7026 14.3113C7.50244 14.1335 7.35362 13.9102 7.27026 13.6626C7.40123 14.1178 7.65856 14.5315 8.01554 14.8608Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask13_5666_110372)">
        <path
          d="M7.29378 13.4274L6.9917 16.6055L10.0185 16.8631L10.3205 13.6851L7.29378 13.4274Z"
          fill="url(#paint13_linear_5666_110372)"
        />
      </g>
      <mask
        id="mask14_5666_110372"
        style={{ 'mask-type': 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="10"
        y="13"
        width="3"
        height="4"
      >
        <path
          d="M12.3503 14.3113L10.0258 16.3551L10.0132 16.3448L10.0277 16.6289L12.0392 14.8608C12.3951 14.531 12.6517 14.1174 12.7826 13.6626C12.7007 13.9108 12.5517 14.1344 12.3503 14.3113Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask14_5666_110372)">
        <path
          d="M12.7611 13.4297L9.73254 13.6875L10.0347 16.8655L13.0632 16.6078L12.7611 13.4297Z"
          fill="url(#paint14_linear_5666_110372)"
        />
      </g>
      <path
        d="M47.6357 18.0315L39.0562 4.54496C38.7491 4.06052 38.3805 3.75049 37.8072 3.75049C37.2338 3.75049 36.8448 4.06052 36.5377 4.54496L27.9786 18.0315H30.9477L37.7048 7.21902L41.0219 12.4896H36.4557L35.2272 14.4855H42.271L44.5029 18.0315H47.6357Z"
        fill={color}
      />
      <path
        d="M59.7014 14.1173C63.1414 14.1173 65.148 12.0246 65.148 8.98235C65.148 5.90136 63.1414 3.94426 59.7014 3.94426H49.2381V18.0315H51.8181V6.40517H59.7014C61.5238 6.40517 62.609 7.43217 62.609 9.05986C62.609 10.6488 61.5238 11.7339 59.7014 11.7339H53.7224V14.1173H59.7014Z"
        fill={color}
      />
      <path
        d="M77.4171 18.0315C81.6556 18.0315 84.7066 14.9312 84.7066 10.8426C84.7066 6.75396 81.7171 3.94426 77.4171 3.94426H73.7928C69.6362 3.94426 66.5647 6.69583 66.5647 10.8426C66.5647 14.9312 69.6362 18.0315 73.7928 18.0315H77.4171ZM73.7928 15.5706C71.1104 15.5706 69.1652 13.6135 69.1652 10.9588C69.1652 8.28477 71.1309 6.40517 73.7928 6.40517H77.4171C80.1609 6.40517 82.1061 8.30414 82.1061 10.9588C82.1061 13.6135 80.1609 15.5706 77.4171 15.5706H73.7928Z"
        fill={color}
      />
      <path d="M99.4243 18.0315V15.5706H89.4114V3.94426H86.811V18.0315H99.4243Z" fill={color} />
      <path
        d="M111.711 18.0315C115.949 18.0315 119 14.9312 119 10.8426C119 6.75396 116.011 3.94426 111.711 3.94426H108.086C103.93 3.94426 100.858 6.69583 100.858 10.8426C100.858 14.9312 103.93 18.0315 108.086 18.0315H111.711ZM108.086 15.5706C105.404 15.5706 103.459 13.6135 103.459 10.9588C103.459 8.28477 105.424 6.40517 108.086 6.40517H111.711C114.454 6.40517 116.4 8.30414 116.4 10.9588C116.4 13.6135 114.454 15.5706 111.711 15.5706H108.086Z"
        fill={color}
      />
      <path
        d="M39.6976 24.2683V26.0312H39.1321V21.6241H40.3961C40.8529 21.6241 41.2299 21.7459 41.5271 21.9893C41.8287 22.2285 41.9795 22.5475 41.9795 22.9462C41.9795 23.345 41.8287 23.6661 41.5271 23.9095C41.2299 24.1487 40.8529 24.2683 40.3961 24.2683H39.6976ZM39.6976 23.7647H40.3961C40.7066 23.7647 40.9527 23.6954 41.1346 23.5569C41.3208 23.4142 41.414 23.2107 41.414 22.9462C41.414 22.6818 41.3208 22.4804 41.1346 22.3419C40.9527 22.1992 40.7066 22.1278 40.3961 22.1278H39.6976V23.7647Z"
        fill={color}
      />
      <path
        d="M42.3776 26.0312L44.5797 23.8088C44.9035 23.4814 45.0653 23.1603 45.0653 22.8455C45.0653 22.6357 44.9899 22.4531 44.8391 22.2978C44.6928 22.1383 44.4866 22.0585 44.2204 22.0585C43.9189 22.0585 43.6749 22.1551 43.4886 22.3482C43.3024 22.5412 43.2092 22.8035 43.2092 23.1351H42.6437C42.6437 22.6608 42.7857 22.2789 43.0695 21.9893C43.3578 21.6997 43.7414 21.5549 44.2204 21.5549C44.4644 21.5549 44.6817 21.5969 44.8724 21.6808C45.0631 21.7606 45.2117 21.8676 45.3181 22.0019C45.429 22.1362 45.5111 22.2789 45.5643 22.43C45.6175 22.5811 45.6441 22.7343 45.6441 22.8896C45.6441 23.2967 45.4379 23.6996 45.0254 24.0984L43.5419 25.5275H45.6641V26.0312H42.3776Z"
        fill={color}
      />
      <path
        d="M47.1299 24.2683V26.0312H46.5644V21.6241H47.8285C48.2853 21.6241 48.6623 21.7459 48.9594 21.9893C49.261 22.2285 49.4118 22.5475 49.4118 22.9462C49.4118 23.345 49.261 23.6661 48.9594 23.9095C48.6623 24.1487 48.2853 24.2683 47.8285 24.2683H47.1299ZM47.1299 23.7647H47.8285C48.1389 23.7647 48.3851 23.6954 48.5669 23.5569C48.7532 23.4142 48.8463 23.2107 48.8463 22.9462C48.8463 22.6818 48.7532 22.4804 48.5669 22.3419C48.3851 22.1992 48.1389 22.1278 47.8285 22.1278H47.1299V23.7647Z"
        fill={color}
      />
      <path
        d="M53.0486 22.5874C52.7071 22.9148 52.5363 23.3282 52.5363 23.8276C52.5363 24.3271 52.7071 24.7405 53.0486 25.0679C53.3901 25.3953 53.7959 25.559 54.266 25.559C54.9003 25.559 55.3992 25.3407 55.7629 24.9042V25.6093C55.377 25.9325 54.8781 26.0941 54.266 26.0941C53.6141 26.0941 53.0619 25.8801 52.6095 25.4519C52.1615 25.0196 51.9376 24.4782 51.9376 23.8276C51.9376 23.1771 52.1615 22.6378 52.6095 22.2096C53.0619 21.7773 53.6141 21.5612 54.266 21.5612C54.8781 21.5612 55.377 21.7228 55.7629 22.046V22.7511C55.3992 22.3146 54.9003 22.0963 54.266 22.0963C53.7959 22.0963 53.3901 22.26 53.0486 22.5874Z"
        fill={color}
      />
      <path
        d="M57.3234 24.2683V26.0312H56.758V21.6241H58.022C58.4788 21.6241 58.8558 21.7459 59.1529 21.9893C59.4545 22.2285 59.6053 22.5475 59.6053 22.9462C59.6053 23.2694 59.5033 23.5443 59.2993 23.771C59.0997 23.9934 58.8314 24.1424 58.4943 24.218L59.8847 26.0312H59.1862L57.8889 24.2683H57.3234ZM57.3234 23.7962H58.022C58.328 23.7962 58.5742 23.7206 58.7604 23.5695C58.9467 23.4184 59.0398 23.2107 59.0398 22.9462C59.0398 22.6818 58.9467 22.4741 58.7604 22.323C58.5742 22.1719 58.328 22.0963 58.022 22.0963H57.3234V23.7962Z"
        fill={color}
      />
      <path
        d="M63.0153 21.6241H63.6473L62.0972 24.1298V26.0312H61.5318V24.1361L59.9817 21.6241H60.6137L61.8112 23.664L63.0153 21.6241Z"
        fill={color}
      />
      <path
        d="M64.7698 24.2771V26.0312H64.2072V21.646H65.4649C65.9195 21.646 66.2946 21.7671 66.5903 22.0094C66.8904 22.2474 67.0404 22.5648 67.0404 22.9616C67.0404 23.3583 66.8904 23.6778 66.5903 23.92C66.2946 24.1581 65.9195 24.2771 65.4649 24.2771H64.7698ZM64.7698 23.7759H65.4649C65.7738 23.7759 66.0188 23.707 66.1997 23.5692C66.3851 23.4272 66.4777 23.2247 66.4777 22.9616C66.4777 22.6984 66.3851 22.498 66.1997 22.3602C66.0188 22.2182 65.7738 22.1472 65.4649 22.1472H64.7698V23.7759Z"
        fill={color}
      />
      <path
        d="M67.17 22.1472V21.646H70.1158V22.1472H68.9242V26.0312H68.3616V22.1472H67.17Z"
        fill={color}
      />
      <path
        d="M70.7846 25.4486C70.3389 25.0184 70.1161 24.4817 70.1161 23.8386C70.1161 23.1954 70.3389 22.6588 70.7846 22.2286C71.2304 21.7985 71.7908 21.5834 72.4661 21.5834C73.1413 21.5834 73.7017 21.7985 74.1475 22.2286C74.5932 22.6588 74.8161 23.1954 74.8161 23.8386C74.8161 24.4817 74.5932 25.0184 74.1475 25.4486C73.7017 25.8787 73.1413 26.0938 72.4661 26.0938C71.7908 26.0938 71.2304 25.8787 70.7846 25.4486ZM71.2083 22.6045C70.8773 22.9302 70.7118 23.3416 70.7118 23.8386C70.7118 24.3356 70.8773 24.7469 71.2083 25.0727C71.5393 25.3984 71.9585 25.5613 72.4661 25.5613C72.9736 25.5613 73.3928 25.3984 73.7238 25.0727C74.0548 24.7469 74.2203 24.3356 74.2203 23.8386C74.2203 23.3416 74.0548 22.9302 73.7238 22.6045C73.3928 22.2787 72.9736 22.1159 72.4661 22.1159C71.9585 22.1159 71.5393 22.2787 71.2083 22.6045Z"
        fill={color}
      />
      <path d="M77.5953 21.646H78.158V25.53H79.9784V26.0312H77.5953V21.646Z" fill={color} />
      <path
        d="M81.1382 23.9012V25.53H83.2234V26.0312H80.5755V21.646H83.2234V22.1472H81.1382V23.4001H83.091V23.9012H81.1382Z"
        fill={color}
      />
      <path
        d="M84.9366 24.7156L84.3474 26.0312H83.7186L85.87 21.4268L88.0214 26.0312H87.3925L86.8034 24.7156H84.9366ZM85.1617 24.2145H86.5783L85.87 22.6358L85.1617 24.2145Z"
        fill={color}
      />
      <path
        d="M89.1478 24.2771V26.0312H88.5851V21.646H89.8428C90.2974 21.646 90.6725 21.7671 90.9682 22.0094C91.2683 22.2474 91.4183 22.5648 91.4183 22.9616C91.4183 23.2831 91.3168 23.5567 91.1138 23.7822C90.9152 24.0035 90.6482 24.1518 90.3128 24.227L91.6964 26.0312H91.0013L89.7105 24.2771H89.1478ZM89.1478 23.8073H89.8428C90.1474 23.8073 90.3923 23.7321 90.5776 23.5817C90.763 23.4314 90.8557 23.2247 90.8557 22.9616C90.8557 22.6984 90.763 22.4917 90.5776 22.3414C90.3923 22.191 90.1474 22.1159 89.8428 22.1159H89.1478V23.8073Z"
        fill={color}
      />
      <path
        d="M95.7978 21.646H96.3604V26.2504L92.852 22.7674V26.0312H92.2893V21.4268L95.7978 24.9098V21.646Z"
        fill={color}
      />
      <path d="M97.4222 21.646H97.9849V26.0312H97.4222V21.646Z" fill={color} />
      <path
        d="M102.553 21.646H103.116V26.2504L99.6075 22.7674V26.0312H99.0448V21.4268L102.553 24.9098V21.646Z"
        fill={color}
      />
      <path
        d="M106.329 24.3084V23.8073H108.48C108.48 24.4462 108.28 24.9871 107.878 25.4298C107.481 25.8725 106.943 26.0938 106.263 26.0938C105.588 26.0938 105.027 25.8808 104.581 25.4548C104.136 25.0288 103.913 24.4901 103.913 23.8386C103.913 23.1871 104.136 22.6483 104.581 22.2223C105.027 21.7964 105.588 21.5834 106.263 21.5834C107.141 21.5834 107.783 21.8945 108.189 22.5168L107.792 22.8613C107.479 22.3643 106.969 22.1159 106.263 22.1159C105.764 22.1159 105.347 22.2766 105.012 22.5982C104.676 22.9198 104.509 23.3332 104.509 23.8386C104.509 24.3439 104.676 24.7574 105.012 25.0789C105.347 25.4005 105.764 25.5613 106.263 25.5613C106.7 25.5613 107.057 25.4444 107.335 25.2105C107.613 24.9725 107.792 24.6718 107.871 24.3084H106.329Z"
        fill={color}
      />
      <defs>
        <linearGradient
          id="paint0_linear_5666_110372"
          x1="15.6638"
          y1="24.2506"
          x2="19.3739"
          y2="24.0938"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="0.21" stopColor="#FDD32B" />
          <stop offset="0.5" stopColor="#FBC128" />
          <stop offset="0.85" stopColor="#F7A223" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5666_110372"
          x1="16.3813"
          y1="13.925"
          x2="16.3813"
          y2="20.8117"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5666_110372"
          x1="16.3426"
          y1="6.92758"
          x2="16.3426"
          y2="17.8594"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5666_110372"
          x1="4.53145"
          y1="24.5265"
          x2="1.15134"
          y2="24.4492"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="0.21" stopColor="#FDD32B" />
          <stop offset="0.5" stopColor="#FBC128" />
          <stop offset="0.85" stopColor="#F7A223" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_5666_110372"
          x1="4.7811"
          y1="13.9247"
          x2="4.7811"
          y2="20.8115"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_5666_110372"
          x1="9.7966"
          y1="9.67042"
          x2="9.7966"
          y2="19.9655"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_5666_110372"
          x1="4.64786"
          y1="6.92734"
          x2="4.64786"
          y2="17.8592"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_5666_110372"
          x1="6.41272"
          y1="7.94138"
          x2="13.3397"
          y2="7.94138"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24" />
          <stop offset="1" stopColor="#BE1E2D" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_5666_110372"
          x1="10.6852"
          y1="17.6012"
          x2="10.6852"
          y2="-3.00771"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="0.23" stopColor="#FDD62B" />
          <stop offset="0.47" stopColor="#FCC829" />
          <stop offset="0.73" stopColor="#F9B225" />
          <stop offset="0.99" stopColor="#F59420" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_5666_110372"
          x1="6.41213"
          y1="7.90488"
          x2="13.3391"
          y2="7.90488"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24" />
          <stop offset="1" stopColor="#BE1E2D" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_5666_110372"
          x1="52.0456"
          y1="29.1365"
          x2="8.15179"
          y2="2.77867"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24" />
          <stop offset="1" stopColor="#BE1E2D" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_5666_110372"
          x1="14.5233"
          y1="6.95018"
          x2="15.0505"
          y2="4.56583"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="0.19" stopColor="#F7C92A" />
          <stop offset="0.56" stopColor="#E49E23" />
          <stop offset="1" stopColor="#CB641B" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_5666_110372"
          x1="5.52947"
          y1="6.92867"
          x2="4.99704"
          y2="4.52022"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="0.19" stopColor="#F7C92A" />
          <stop offset="0.56" stopColor="#E49E23" />
          <stop offset="1" stopColor="#CB641B" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_5666_110372"
          x1="9.81256"
          y1="15.3794"
          x2="8.09119"
          y2="15.2157"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="0.19" stopColor="#F7C92A" />
          <stop offset="0.56" stopColor="#E49E23" />
          <stop offset="1" stopColor="#CB641B" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_5666_110372"
          x1="10.7315"
          y1="15.3794"
          x2="12.4528"
          y2="15.2151"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="0.19" stopColor="#F7C92A" />
          <stop offset="0.56" stopColor="#E49E23" />
          <stop offset="1" stopColor="#CB641B" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default LogoWithText
